import type { FollowingEvent } from '@/components/following/helpers/sectionHelper';

import {
	isInterviewReportProfileHistoryType,
	isProfileHistoryNoteType,
	isWorkerContactedProfileHistoryType,
} from '@/components/following/helpers/profileHistoryActivityToFollowingMapper';
import { WorkerActivitySource } from '@/components/following/types';

export enum FollowingFilterCategory {
	Besoin = 'besoin',
	Mission = 'mission',
	Candidature = 'candidature',
	Modification = 'modification',
	Contact = 'contact',
	Note = 'note',
	Interview = 'interview',
}

const getProfileHistoryFilterCategory = (
	type: string | undefined
): FollowingFilterCategory => {
	if (isProfileHistoryNoteType(type)) return FollowingFilterCategory.Note;
	if (isWorkerContactedProfileHistoryType(type))
		return FollowingFilterCategory.Contact;
	if (isInterviewReportProfileHistoryType(type))
		return FollowingFilterCategory.Interview;
	return FollowingFilterCategory.Modification;
};

export const getFollowingFilterCategory = (
	event: FollowingEvent
): FollowingFilterCategory => {
	switch (event.source) {
		case WorkerActivitySource.BESOIN:
			return FollowingFilterCategory.Besoin;
		case WorkerActivitySource.MISSIONS:
			return FollowingFilterCategory.Mission;
		case WorkerActivitySource.JOBOFFERS:
			return FollowingFilterCategory.Candidature;
		case WorkerActivitySource.PROFILE_HISTORY:
			return getProfileHistoryFilterCategory(event.profileHistoryType);
		default: {
			const _exhaustive: never = event.source;
			return _exhaustive;
		}
	}
};
